import axios from "axios";
import { setMessage, setStatus, store } from "state";

export const BASEURL = "https://apigate.primacentre.id";
// export const BASEURL = "http://localhost:3000";
const API = axios.create({
  baseURL: BASEURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor untuk menambahkan token auth
API.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.user.accessToken; // Ambil token dari Redux Persist
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Interceptor Response (Tangani Error)
API.interceptors.response.use(
  (response) => response, // Jika sukses, lanjutkan
  (error) => {
    const errorMessage =
      error.response?.data?.error || "Terjadi kesalahan pada server";

    // Dispatch ke Redux Global State
    store.dispatch(setMessage(errorMessage));
    store.dispatch(setStatus("failed"));

    return Promise.reject(error);
  },
);
export default API;
